import {fetching} from "./index";

import * as routesApi from "../constants/api"

export function listAction(officeId, date) {
    return fetching("CALENDAR_LIST", routesApi.calendar.list.replace(":officeId", officeId).replace(":date", date));
}